import { createContext, useReducer } from "react";

export const StateContext = createContext({
	currentSession: null,
	setCurrentSession: () => null,
});

export const STATE_ACTION_TYPES = {
	SET_CURRENT_SESSION: "SET_CURRENT_SESSION",
};

const stateReducer = (state, action) => {
	const { type, payload } = action;

	switch (type) {
		case STATE_ACTION_TYPES.SET_CURRENT_SESSION:
			return {
				...state,
				currentSession:
					payload === null
						? null
						: {
								...state.currentSession,
								...payload,
							},
			};

		default:
			throw new Error(`Unhandled type ${type} in stateReducer`);
	}
};

export const StateProvider = ({ children }) => {
	const [{ currentSession }, currentSessionDispatch] = useReducer(
		stateReducer,
		{
			currentSession: null,
		},
	);

	const setCurrentSession = (session) => {
		currentSessionDispatch({
			type: STATE_ACTION_TYPES.SET_CURRENT_SESSION,
			payload: session,
		});
	};

	const value = {
		currentSession,
		setCurrentSession,
	};

	return (
		<StateContext.Provider value={value}>{children}</StateContext.Provider>
	);
};
